import React, { useState, useEffect } from "react";
import styles from "./BussinessAddress.module.css";
import FooterButton from "uicomponents/FooterButton";
import { BusinessAddressType, SingleBusinessAddressType } from "types";
import BusinessAddressForm from "./components/BusinessAddressForm";
import {
  BACK_BUTTON_TEXT,
  NEXT_BUTTON_TEXT,
  LOADING_BUTTON_TEXT,
} from "pages/WorkersCompApplcation/utils/contants";
import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { trackPageViewUserStep } from "utils/analytics/trackEvent";
interface IBusinessAddressProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
  data: BusinessAddressType;
}

const BusinessAddress = ({ ...props }: IBusinessAddressProps): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(2, "office location");
  }, []);
  const { setNextStep, setPreviousStep, data } = props;
  const sortedOfficeLocations = data?.officeLocations?.sort((a, b) =>
    a.isHq ? -1 : 1
  );

  const [officeAddressList, setOfficeAddressList] = useState(
    sortedOfficeLocations
  );
  const [isEditing, setIsEditing] = useState(
    officeAddressList?.length ? false : true
  );
  const [addNewAddress, setAddNewAddress] = useState(
    data?.officeLocations?.length ? false : true
  );
  const [isLoadingSteps, setIsLoadingSteps] = useState(false);

  const updateOfficeAddressList = (
    operation: string,
    newAddress?: SingleBusinessAddressType,
    uuid?: string
  ) => {
    if (operation === "Add" && newAddress) {
      addOfficeAddressList(newAddress);
    }
    if (operation === "Delete") {
      deleteOfficeAddressList(uuid);
    }
  };

  const addOfficeAddressList = (newAddress: SingleBusinessAddressType) => {
    if (!officeAddressList) {
      return;
    }
    const hasAddressIndex = officeAddressList?.findIndex(
      (address) => address?.uuid === newAddress?.uuid
    );

    // Update exisitng address
    if (hasAddressIndex >= 0) {
      let newAddressList = [...officeAddressList];
      newAddressList[hasAddressIndex] = newAddress;
      setOfficeAddressList(newAddressList);
    } else {
      // Add new address
      setOfficeAddressList([...officeAddressList, newAddress]);
    }
    setAddNewAddress(false);
  };

  const deleteOfficeAddressList = (uuid?: string) => {
    // Delete Address
    const newAddressList = officeAddressList?.filter(
      (address) => address?.uuid !== uuid
    );

    // Need atlease 1 address
    if (newAddressList?.length === 0) {
      setAddNewAddress(true);
    } else {
      setAddNewAddress(false);
    }
    setOfficeAddressList(newAddressList);
  };

  const handleAddNewAddress = () => {
    setIsEditing(true);
    setAddNewAddress(true);
  };

  const updateIsEditing = (updateIsEditing: boolean) => {
    setIsEditing(updateIsEditing);
  };

  const handleBack = (): void => {
    setPreviousStep();
  };

  const handleNext = () => {
    setIsLoadingSteps(true);
    setNextStep();
  };

  return (
    <>
      <div className={styles.title}>
        {sectionsQuestions["officeLocation"].title}
      </div>
      <div className={styles.description}>
        {sectionsQuestions["officeLocation"].description}
      </div>
      {officeAddressList?.length ? (
        officeAddressList.map((address, index) => {
          return (
            <BusinessAddressForm
              key={index}
              isPrimaryAddress={address.isHq}
              data={address}
              employeeData={data?.employeeCensuses}
              updateOfficeAddressList={updateOfficeAddressList}
              officeAddressList={officeAddressList}
              updateIsEditing={updateIsEditing}
              handleAddNewAddress={handleAddNewAddress}
              application={data?.applications?.[0]}
            />
          );
        })
      ) : (
        <></>
      )}
      {addNewAddress && (
        <BusinessAddressForm
          updateOfficeAddressList={updateOfficeAddressList}
          updateIsEditing={updateIsEditing}
          isPrimaryAddress={!officeAddressList?.length}
          officeAddressList={officeAddressList}
          handleAddNewAddress={handleAddNewAddress}
          employeeData={data?.employeeCensuses}
          application={data?.applications?.[0]}
        />
      )}
      <FooterButton
        nextButtonText={isLoadingSteps ? LOADING_BUTTON_TEXT : NEXT_BUTTON_TEXT}
        backButtonText={BACK_BUTTON_TEXT}
        buttonType="button"
        handleBackClick={handleBack}
        handleNextClick={handleNext}
        disabled={
          isEditing || isLoadingSteps || officeAddressList?.length === 0
        }
      />
    </>
  );
};

export default BusinessAddress;
